export const upsellings = {
    text1: "Serviços",
    text2: "Gerencie seus serviços",
    text3: "Lista de serviços",
    text4: "Fornecedores",
    text5: "Lista de serviços que seus hóspedes verão",
    text6: "Cadastrar serviço",
    text7: "Nome",
    text8: "Criado",
    text9: "Estado",
    text10: "ativo",
    text11: "inativo",
    text12: "Editar serviço",
    text13: "Excluir serviço",
    text14: "Nenhum serviço encontrado.",
    text15: "Alterado com sucesso.",
    text16: "Tem certeza de que deseja excluir o serviço",
    text17: "Você perderá seus dados salvos",
    text18: "Excluir serviço",
    text19: "Cancelar",
    text20: "Excluído com sucesso.",
    text21: "Criar serviço",
    text22: "Informações do serviço",
    text23: "Insira as principais informações do serviço exibidas no card.",
    text24: "Todas as propriedades",
    text25: "Selecionar propriedade *",
    text26: "Insira o nome",
    text27: "Nome do seu serviço *",
    text28: "Automático",
    text29: "Manual",
    text30: "Tipo de confirmação",
    text31: "Título do serviço",
    text32: "Insira o título *",
    text33: "Check-in/check-out",
    text34: "Transfer",
    text35: "F&B",
    text36: "Sazonal",
    text37: "Família",
    text38: "Romântico",
    text39: "SPA & Saúde",
    text40: "Arte & Cultura",
    text41: "Atividades",
    text42: "Serviços",
    text43: "Outros",
    text44: "Categoria *",
    text45: "Serviço interno",
    text46: "Fornecedor *",
    text47: "Descrição",
    text48: "Insira a descrição do seu serviço *",
    text49: "Preço",
    text50: "Selecione o tipo de preço e defina quanto seus hóspedes pagarão pela oferta.",
    text51: "Insira o número",
    text52: "Por unidade",
    text53: "Por pessoa",
    text54: "Por grupo",
    text55: "Por dia",
    text555: "Por hora",
    text56: "Preço por",
    text57: "Imagem",
    text58: "Envie uma imagem que será posicionada no cabeçalho do card.",
    text59: "Salvar serviço",
    text60: "Carregando ...",
    text61: "Serviço criado com sucesso.",
    text62: "Lista de fornecedores",
    text63: "Adicionar fornecedor",
    text64: "ID",
    text65: "Nome",
    text66: "E-mail",
    text67: "Telefone",
    text68: "Editar fornecedor",
    text69: "Remover fornecedor",
    text70: "Cadastrar fornecedor",
    text71: "Adicionar ",
    text72: "fornecedores ",
    text73: "à sua lista para que você possa usá-los na criação de novas ofertas.",
    text74: "Insira o nome",
    text75: "Nome do fornecedor *",
    text76: "País",
    text77: "Erro",
    text78: "Insira seu número",
    text79: "Telefone *",
    text80: "Endereço de e-mail *",
    text81: "Endereço",
    text82: "Adicionar fornecedor",
    text83: "Criado com sucesso.",
    text84: "Tem certeza de que deseja excluir o fornecedor?",
    text85: "Você perderá seus dados salvos",
    text86: "Remover fornecedor",
    text87: "Excluído com sucesso.",
    text96: 'Gerencie suas assinaturas e faturas',

    // Correcciones
    p1: "Preço sob consulta",
};
